import { render } from "./v-select.vue?vue&type=template&id=79ee748c&scoped=true"
import script from "./v-select.vue?vue&type=script&lang=js"
export * from "./v-select.vue?vue&type=script&lang=js"

import "./v-select.vue?vue&type=style&index=0&id=79ee748c&scoped=true&lang=css"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ee748c"]])

export default __exports__